'use strict';

var _commonjsHelpers = require('./_commonjsHelpers.js');
var index = require('../node_modules/@material-ui/styles/esm/index.js');

var require$$1 = /*@__PURE__*/_commonjsHelpers.getAugmentedNamespace(index);

module.exports = require$$1;
